// noinspection JSUnusedLocalSymbols

import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { CacheService } from '../../../../../services/cache-service';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastService } from '../../../../../services/toast-service';
import {
  EmployerAuthFlow,
  EmployerAuthFlowSubtext,
  EmployerAuthFlowTitle
} from '../../../../../models/users/enum/employer-auth-flow.enum';
import { BaseAuthViewModel } from '../../../../../models/base/base-auth-view-model';
import { ChoosePasswordRequest } from '../../../../../models/users/requests/choose-password-request';

@Injectable()
export class EmployerAuthViewModel extends BaseAuthViewModel {
  constructor(public cacheService: CacheService, public router: Router, public toastService: ToastService) {
    super(router, toastService, cacheService);
    this.init();
  }

  // Observables
  public nextAuthFlow: Subject<EmployerAuthFlow> = new Subject<EmployerAuthFlow>();

  public authFlowMap = new Map<number, EmployerAuthFlow>();

  public readonly authFlowTitle$ = this.authFlow$.pipe(map(flow => EmployerAuthFlowTitle(flow)));
  public readonly authFlowSubtext$ = this.authFlow$.pipe(map(flow => EmployerAuthFlowSubtext(flow)));

  public showBackButton$ = this.authFlow$.pipe(
    map(flow => {
      return flow !== EmployerAuthFlow.SignIn;
    })
  );

  init() {
    super.init();
    this.generateAuthFlowMap();
  }

  // Auth Flows

  goBack(): void {
    this.authFlow$.once(flow => {
      switch (flow) {
        case EmployerAuthFlow.ResetPassword: {
          this.router.navigate(['auth/forgot-password']).then();
          break;
        }
        case EmployerAuthFlow.ForgotPassword: {
          this.router.navigate(['auth/sign-in']).then();
          break;
        }
        case EmployerAuthFlow.EmployerChoosePassword: {
          this.router.navigate(['auth/sign-in']).then();
          break;
        }
        case EmployerAuthFlow.EmployerMFAVerification: {
          this.router.navigate(['/auth/sign-in']).then();
          break;
        }
      }
    });
  }

  public generateAuthFlowMap() {
    this.authFlowMap?.set(0, EmployerAuthFlow.SignIn);
    this.authFlowMap?.set(1, EmployerAuthFlow.ForgotPassword);
    this.authFlowMap?.set(2, EmployerAuthFlow.ResetPassword);
    this.authFlowMap?.set(3, EmployerAuthFlow.SetNewPassword);
    this.authFlowMap?.set(4, EmployerAuthFlow.EmployerChoosePassword);
  }

  // Auth Requests

  public setNewEmployerPassword(req: ChoosePasswordRequest): void {
    const loadingMessage = $localize`Signing in`;
    this._loadingOpts.addRequest(loadingMessage);
    this.userDomainModel.setNewEmployerPassword(req).subscribe({
      next: res => {
        this._loadingOpts.removeRequest(loadingMessage);
        this.toastService.publishSuccessMessage($localize`Success`, $localize`Your password has been confirmed.`);
        this.router.navigate(['/dashboard'], { replaceUrl: true }).then(() => {});
      },
      error: error => {
        this.toastService.publishErrorMessage('Error', error);
        this._loadingOpts.removeRequest(loadingMessage);
      }
    });
  }
}
